import {useEffect, useRef} from "react";
import usePrevious from "./use-previous";

/**
 * Custom React hook that triggers a callback function when all dependencies in the dependencies
 * array have changed compared to their previous values.
 *
 * @param {Function} callBack - The callback function to execute when all dependencies have changed.
 * @param {Array<any>} deps - An array of dependencies to monitor for changes. All dependencies
 * must change simultaneously for the callback to be triggered.
 */
export const useEffectAllDepsChange = (callBack: () => void, deps: any[]) => {
    const prevDeps = usePrevious(deps);
    const changeTarget = useRef<any>();

    useEffect(() => {
        if (changeTarget.current === undefined) changeTarget.current = prevDeps;
        if (changeTarget.current && changeTarget.current.every((dep: any, i: number) => dep !== deps[i])) {
            changeTarget.current = deps
            return callBack()
        }
    }, [callBack, prevDeps, deps]);
}